import { getRouteApi } from "@tanstack/react-router";
import { defaultSiteNavSettings } from "@/lib/navigation/defaults";
import type { NavItem, SiteNavSettings } from "@/lib/navigation/types";
import { articles, clientStories, serviceCategories } from "@/lib/content";

const rootRoute = getRouteApi("__root__");

export type MegaMenuData = {
  services: typeof serviceCategories;
  insights: typeof articles;
  stories: typeof clientStories;
};

const defaultMegaMenuData: MegaMenuData = {
  services: serviceCategories,
  insights: articles,
  stories: clientStories,
};

export function useSiteNav(): SiteNavSettings & { megaMenu: MegaMenuData } {
  const settings = rootRoute.useLoaderData();
  const nav = settings.nav ?? defaultSiteNavSettings;
  const megaMenu = settings.megaMenu ?? defaultMegaMenuData;

  return {
    headerMenu: nav.headerMenu,
    footerMenu: nav.footerMenu,
    footerServiceSlugs: nav.footerServiceSlugs,
    megaMenu,
  };
}

export function visibleNavItems(items: NavItem[]): NavItem[] {
  return items.filter((item) => item.visible);
}
